import { Component, OnInit, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'cake-price-total',
  templateUrl: './cake-price-total.component.html',
  styleUrls: ['./cake-price-total.component.scss']
})
export class CakePriceTotalComponent implements OnInit {
  @Input() totalPrice = 0;
  @Input() extraPrice = 0;
  @Input() currency = '';

  constructor() { }

  ngOnInit() {
  }

}
